import React, { memo } from 'react';
import { FormSelect, FormSelectItem } from '@core/components/form';
import { FormHTML } from '@core/components/form/FormHTML';
import { TableColumn } from '@modules/common/TableColumn';
import { TableActions } from '@modules/common/TableActions';

interface CategoryNoteItemProps {
  ctrl: any;
  index: number;
  categoryItems: FormSelectItem<any, any>[];
  onDelete: () => void;
}

export const CategoryNoteItem = memo((props: CategoryNoteItemProps) => {
  const { ctrl, index, categoryItems, onDelete } = props;

  return (
    <div key={index} className="d-flex align-items-start mb-3">
      <TableColumn flex={2}>
        <FormSelect control={ctrl.controls.categoryId} items={categoryItems} />
        <FormHTML veryMinimal control={ctrl.controls.note} />
      </TableColumn>
      <TableColumn flex={0.1} minWidth={'75'} maxWidth={'75'}>
        <TableActions onDelete={onDelete} />
      </TableColumn>
    </div>
  );
});
